// Configuração de status e cores para Pedidos em Análise
export const statusConfig = {
  'Aguardando Aprovação': { colorScheme: 'yellow', description: 'Pedido cadastrado e aguardando análise e aprovação' },
  Aprovado: { colorScheme: 'green', description: 'Pedido aprovado e pronto para produção' },
  Reprovado: { colorScheme: 'red', description: 'Pedido reprovado por inconsistências ou incompatibilidades' },
}

// Array de status para uso em selects
export const statusArray = Object.keys(statusConfig)

// Função para obter a cor com base no status
export function getStatusColor(status) {
  // Normaliza o status removendo variações de capitalização
  const normalizedStatus = Object.keys(statusConfig).find((key) => key.toLowerCase() === status?.toLowerCase())

  return statusConfig[normalizedStatus]?.colorScheme || 'gray'
}
